import { CONFIG } from './config'

export const VALIDGUESSES = [
  'a giao',
  'a hoàn',
  'a phiến',
  'a tòng',
  'ả hoàn',
  'á khôi',
  'á phiện',
  'á quân',
  'á sừng',
  'á thánh',
  'ác cảm',
  'ác độc',
  'ác đức',
  'ác hại',
  'ác khẩu',
  'ác mộng',
  'ác nhân',
  'ác quỉ',
  'ác thú',
  'ác tính',
  'ác vàng',
  'aceton',
  'acetylen',
  'ách tắc',
  'ách vận',
  'ad hoc',
  'ai bảo',
  'ai lại',
  'ai nấy',
  'ai ngờ',
  'ai oán',
  'ải quan',
  'ải thâm',
  'ái chà',
  'ái hữu',
  'ái khanh',
  'ái lực',
  'ái ngại',
  'ái phi',
  'ái quần',
  'ái quốc',
  'ái tình',
  'ảm đạm',
  'ám ảnh',
  'ám chỉ',
  'ám hại',
  'ám quẻ',
  'ám sát',
  'ám thị',
  'amiđan',
  'ampere',
  'an bài',
  'an bình',
  'an giấc',
  'an khang',
  'an nhàn',
  'an ninh',
  'an phận',
  'an táng',
  'an tâm',
  'an thai',
  'an thần',
  'an tọa',
  'an trí',
  'án gian',
  'án mạng',
  'án ngữ',
  'án phí',
  'án sát',
  'án thư',
  'án treo',
  'áng chừng',
  'angorit',
  'anh ách',
  'anh ánh',
  'anh chàng',
  'anh chị',
  'anh dũng',
  'anh đào',
  'anh em',
  'anh hào',
  'anh hoa',
  'anh hùng',
  'anh linh',
  'anh minh',
  'anh quân',
  'anh tài',
  'anh thư',
  'anh trai',
  'anh túc',
  'anh vũ',
  'ảnh ảo',
  'ảnh âm',
  'ảnh ẩn',
  'ảnh thật',
  'ánh kim',
  'ánh ỏi',
  'ánh sáng',
  'anofen',
  'ao ước',
  'ảo đăng',
  'ảo giác',
  'ảo hóa',
  'ảo mộng',
  'ảo não',
  'ảo thanh',
  'ảo vọng',
  'áo bào',
  'áo bay',
  'áo bìa',
  'áo bông',
  'áo cánh',
  'áo choàng',
  'áo cối',
  'áo dài',
  'áo gai',
  'áo giáp',
  'áo gió',
  'áo hạt',
  'áo kén',
  'áo khách',
  'áo khoác',
  'áo lặn',
  'áo lót',
  'áo mưa',
  'áo nậu',
  'áo nhộng',
  'áo phao',
  'áo phông',
  'áo quan',
  'áo quần',
  'áo rộng',
  'áo tắm',
  'áo thụng',
  'áo tơi',
  'áo xống',
  'áp bức',
  'áp chảo',
  'áp chế',
  'áp dẫn',
  'áp dụng',
  'áp đảo',
  'áp đặt',
  'áp giá',
  'áp giải',
  'áp lực',
  'áp phích',
  'áp tải',
  'áp thấp',
  'apatit',
  'áp phích',
  'asphalt',
  'axeton',
  'áy náy',
  'austral',
  'ăccoóc',
  'ẵm ngửa',
  'ăn bám',
  'ăn bẩn',
  'ăn bận',
  'ăn bớt',
  'ăn cám',
  'ăn cánh',
  'ăn cắp',
  'ăn chay',
  'ăn chặn',
  'ăn chẹt',
  'ăn chia',
  'ăn chịu',
  'ăn chơi',
  'ăn chực',
  'ăn đất',
  'ăn đong',
  'ăn đứt',
  'ăn ghém',
  'ăn giá',
  'ăn gian',
  'ăn giơ',
  'ăn gỏi',
  'ăn hại',
  'ăn hàng',
  'ăn học',
  'ăn hỏi',
  'ăn hớt',
  'ăn khách',
  'ăn không',
  'ăn khớp',
  'ăn làm',
  'ăn lời',
  'ăn mày',
  'ăn mặc',
  'ăn mòn',
  'ăn mừng',
  'ăn nằm',
  'ăn năn',
  'ăn ngọn',
  'ăn nhằm',
  'ăn nhập',
  'ăn nhậu',
  'ăn nhịp',
  'ăn nói',
  'ăn quịt',
  'ăn rỗi',
  'ăn tạp',
  'ăn theo',
  'ăn thề',
  'ăn thua',
  'ăn trầu',
  'ăn trộm',
  'ăn uống',
  'ăn vận',
  'ăn xài',
  'ăn xin',
  'ăn xổi',
  'ăng ẳng',
  'ắng cổ',
  'ắng lặng',
  'ăng ten',
  'ắt hẳn',
  'âm bản',
  'âm binh',
  'âm bội',
  'âm chủ',
  'âm cung',
  'âm cực',
  'âm đạo',
  'âm đức',
  'âm giai',
  'âm hao',
  'âm học',
  'âm hồn',
  'âm khí',
  'âm khu',
  'âm lịch',
  'âm mưu',
  'âm nang',
  'âm nhạc',
  'âm phần',
  'âm phủ',
  'âm sắc',
  'âm tạp',
  'âm tần',
  'âm thanh',
  'âm thầm',
  'âm thoa',
  'âm tín',
  'âm tính',
  'âm trình',
  'âm vang',
  'âm vực',
  'ẩm thấp',
  'ẩm thực',
  'ẩm ương',
  'ẩm ướt',
  'ẩm ách',
  'ẩm xìu',
  'ấm cúng',
  'ấm đầu',
  'ấm oái',
  'ấm sinh',
  'ấm tích',
  'ậm ạch',
  'ân cần',
  'ân đức',
  'ân giảm',
  'ân huệ',
  'ân nghĩa',
  'ân nhân',
  'ân oán',
  'ân tình',
  'ẩn chứa',
  'ẩn danh',
  'ẩn dật',
  'ẩn giấu',
  'ẩn hoa',
  'ẩn lậu',
  'ẩn náu',
  'ẩn nặc',
  'ẩn nấp',
  'ẩn ngữ',
  'ẩn nhẫn',
  'ẩn núp',
  'ấn bản',
  'ấn định',
  'ấn hành',
  'ấn tín',
  'ấp úng',
  'âu đất',
  'âu hóa',
  'âu nổi',
  'âu phục',
  'âu sầu',
  'âu tàu',
  'âu yếm',
  'ấu học',
  'ấu thơ',
  'ấu trĩ',
  'ba-lát',
  'ba-zan',
  'ba bảy',
  'ba bốn',
  'ba chỉ',
  'ba gai',
  'ba gạc',
  'ba rọi',
  'ba đào',
  'ban sơ',
  'bao bố',
  'bao tử',
  'bao xa',
  'barrel',
  'batinê',
  'bi cảm',
  'bi lắc',
  'bobbin',
  'bà già',
  'bài vị',
  'bàn cờ',
  'bàn là',
  'bàn ra',
  'bàn rà',
  'bác sĩ',
  'bái tạ',
  'bán hạ',
  'bán độ',
  'bom thư',
  'bàn thờ',
  'ba kích',
  'bo mạch',
  'bào chế',
  'bách bộ',
  'ba trợn',
  'bán trú',
  'binh mã',
  'bà nhạc',
  'bành tô',
  'bao phủ',
  'bi hùng',
  'bi đông',
  'báng bổ',
  'bao giờ',
  'ba-ren',
  'ba gác',
  'ba láp',
  'ba que',
  'ba rem',
  'ba soi',
  'ba đậu',
  'ban bố',
  'bao la',
  'bi-tum',
  'bi chí',
  'bi luỵ',
  'bia ôm',
  'bo bíu',
  'bom bi',
  'bunker',
  'bà con',
  'bà gia',
  'bà trẻ',
  'bào tử',
  'bày tỏ',
  'bá cáo',
  'bác cổ',
  'bác mẹ',
  'bác ái',
  'bán sỉ',
  'ba hoa',
  'ba lơn',
  'ba xạo',
  'ban bệ',
  'ban ơn',
  'bao bì',
  'basalt',
  'be bét',
  'bi đát',
  'biogas',
  'bà cốt',
  'bài vở',
  'bàn ủi',
  'bày vẽ',
  'bá chủ',
  'bá láp',
  'bác bỏ',
  'bái tổ',
  'bán lẻ',
  'bi kịch',
  'bà chúa',
  'bài trí',
  'bá trạo',
  'bám trụ',
  'ba khía',
  'bi khúc',
  'ba sinh',
  'binh bị',
  'ba cùng',
  'bu lông',
  'bánh ú',
  'báo ơn',
  'bã bời',
  'bão từ',
  'bè bạn',
  'bé con',
  'bé nhỏ',
  'béo bở',
  'bét be',
  'bê bối',
  'bê trễ',
  'bên bị',
  'bì thư',
  'bí đao',
  'bò cạp',
  'bó giò',
  'bô lão',
  'bôn ba',
  'bõ bèn',
  'bù giá',
  'bù trì',
  'bù đầu',
  'bùa bả',
  'búp bê',
  'bút bi',
  'bạc hà',
  'bạt tử',
  'bả vai',
  'báo bổ',
  'báo hỉ',
  'báo vụ',
  'báo ân',
  'bát cú',
  'bát âm',
  'bê trệ',
  'bì bõm',
  'bí ngô',
  'bí thơ',
  'bò hóc',
  'bò sát',
  'bó gối',
  'bó tay',
  'bóc mẽ',
  'bói cá',
  'bóp cổ',
  'bóp óc',
  'bô-bin',
  'bõ già',
  'bù khú',
  'bù trừ',
  'bù đắp',
  'búi rễ',
  'bún bò',
  'bút kí',
  'bơ phờ',
  'bạc ác',
  'bả dột',
  'báo an',
  'báo cô',
  'báo hỷ',
  'báo tử',
  'bát cổ',
  'bãi bỏ',
  'bãi cá',
  'bão tố',
  'bé dại',
  'bé mọn',
  'béo mỡ',
  'bét tĩ',
  'bê bết',
  'bê tha',
  'bí bét',
  'bí mật',
  'bí thư',
  'bò tót',
  'bó hẹp',
  'bú mớm',
  'búa tạ',
  'búi tó',
  'bút dạ',
  'băm bổ',
  'bơ thờ',
  'bưu tá',
  'bạc má',
  'bại lộ',
  'bạn bè',
  'báo chữ',
  'bí danh',
  'búa gió',
  'bầu eo',
  'bật mí',
  'bắt bí',
  'bắt bồ',
  'bắt rễ',
  'bắt ấn',
  'bẻ lái',
  'bề tôi',
  'bể cạn',
  'bị cáo',
  'bọ gạo',
  'bọ rầy',
  'bọ xít',
  'bỏ nhỏ',
  'bỏ quá',
  'bố cáo',
  'bố già',
  'bố lếu',
  'bố tời',
  'bốc dỡ',
  'bốc mộ',
  'bồ cào',
  'bồ kếp',
  'bồ tát',
  'bồ đào',
  'bồi bổ',
  'bổ túc',
  'bộ dàn',
  'bộ môn',
  'bộ đội',
  'bội số',
  'bội ơn',
  'bộn bề',
  'bờ cõi',
  'bở vía',
  'bỡ ngỡ',
  'bụ sữa',
  'bức tử',
  'bữa ni',
  'bữa tê',
  'bực bõ',
  'ca cao',
  'ca hát',
  'ca táp',
  'cam go',
  'can án',
  'cao kì',
  'bầu cử',
  'bầu sô',
  'bậy bạ',
  'bắp vế',
  'bắt bớ',
  'bắt nợ',
  'bắt vạ',
  'bẹ mèo',
  'bẻ bai',
  'bẻ ghi',
  'bế tắc',
  'bến bờ',
  'bến xe',
  'bề mặt',
  'bề thế',
  'bể dâu',
  'bệ rạc',
  'bỉ bai',
  'bị can',
  'bị gậy',
  'bị đơn',
  'bọ cạp',
  'bọ gậy',
  'bọ mạt',
  'bọ nẹt',
  'bọ trĩ',
  'bỏ mối',
  'bỏ ngũ',
  'bỏ rơi',
  'bỏ xác',
  'bỏ đời',
  'bố cục',
  'bố láo',
  'bố thí',
  'bốn bể',
  'bồ các',
  'bồ hòn',
  'bồ kết',
  'bồ nhí',
  'bồ tạt',
  'bồi tụ',
  'bổ củi',
  'bổ trợ',
  'bộ lạc',
  'bộ mặt',
  'bộ sậu',
  'bộ tộc',
  'bộ vạt',
  'bộ đàm',
  'bộc lộ',
  'bờ bến',
  'bờ rào',
  'bởi vì',
  'bợ đít',
  'ca-líp',
  'ca huế',
  'ca cẩm',
  'ca múa',
  'ca nhi',
  'ca vát',
  'cam bù',
  'can-xi',
  'can cớ',
  'can hệ',
  'bần sĩ',
  'bập bẹ',
  'bắp cơ',
  'bắt bẻ',
  'bắt ép',
  'bẻ bão',
  'bẻ hoẹ',
  'bẽ mặt',
  'bế mạc',
  'bề bộn',
  'bền bỉ',
  'bể bơi',
  'bể khổ',
  'bị chú',
  'bị trị',
  'bọ chó',
  'bọ dừa',
  'bọ mát',
  'bọ mắm',
  'bọ que',
  'bọ rùa',
  'bỏ cha',
  'bỏ mứa',
  'bỏ ngỏ',
  'bỏ qua',
  'bỏ túi',
  'bố trí',
  'bốc mả',
  'bồ câu',
  'bồ đài',
  'bổ bán',
  'bổ ngữ',
  'bổ trụ',
  'bổ ích',
  'bộ máy',
  'bộ nhớ',
  'bộ não',
  'bột nở',
  'bớt xớ',
  'bờ bụi',
  'bờ mẫu',
  'bụ bẫm',
  'bụi bờ',
  'bức xạ',
  'cd-rom',
  'ca-tốt',
  'ca bin',
  'ca dao',
  'ca trù',
  'calory',
  'camera',
  'can dự',
  'cao cả',
  'cao kỳ',
  'bản vị',
  'bản âm',
  'bảo an',
  'bảo hộ',
  'bất đồ',
  'bản lề',
  'bản xứ',
  'bất an',
  'bất cứ',
  'bất kể',
  'bất ổn',
  'bản vẽ',
  'bản án',
  'bản đồ',
  'bảo kê',
  'bảo vệ',
  'bất hủ',
  'bất kì',
  'bất kỳ',
  'bất tử',
  'bản vẽ',
  'bản án',
  'bản đồ',
  'bảo kê',
  'bảo vệ',
  'bất hủ',
  'bất kì',
  'bất kỳ',
  'bất tử',
  'cao su',
  'cao xạ',
  'cao ốc',
  'cau có',
  'cha mẹ',
  'cha xứ',
  'chi bộ',
  'chi uỷ',
  'chiêng',
  'choang',
  'choàng',
  'choòng',
  'choạng',
  'chu kỳ',
  'chu vi',
  'chuyên',
  'chuyến',
  'chuộng',
  'chà là',
  'chây ì',
  'chí lí',
  'chí tử',
  'cao độ',
  'carbur',
  'casino',
  'cay cú',
  'cay sè',
  'cha cố',
  'chiềng',
  'choáng',
  'chu du',
  'chu sa',
  'chuyền',
  'chuông',
  'chuồng',
  'chí lý',
  'chí ít',
  'cao uỷ',
  'cao xa',
  'cao áp',
  'carbon',
  'cartel',
  'cation',
  'cay xè',
  'cha đẻ',
  'che mờ',
  'chi li',
  'chi tử',
  'cho dù',
  'choảng',
  'chu kì',
  'chuyển',
  'chuyện',
  'chè lá',
  'chè nụ',
  'chí sĩ',
  'chú âm',
  'chướng',
  'chường',
  'chế áp',
  'chủ hộ',
  'chủ sự',
  'chủ xị',
  'chủ đề',
  'chó má',
  'chư vị',
  'chưởng',
  'chỉ dụ',
  'chỉ số',
  'chị em',
  'chủ nô',
  'chủ tế',
  'chủ từ',
  'chứ lị',
  'chò hỏ',
  'chó đẻ',
  'chú rể',
  'chơ vơ',
  'chương',
  'chả bù',
  'chả là',
  'chế độ',
  'chỉ vẽ',
  'chủ nợ',
  'chữ ký',
  'co-ban',
  'co cụm',
  'cobalt',
  'coi bộ',
  'con nụ',
  'con xỏ',
  'cu cậu',
  'cua dẽ',
  'cua rơ',
  'cua đá',
  'cà khổ',
  'cà kếu',
  'cà phê',
  'cà rốt',
  'cà vạt',
  'cày ải',
  'cá cóc',
  'cá gáy',
  'cá hẻn',
  'cá kìm',
  'cá lầm',
  'cá mại',
  'cá ngừ',
  'cá nóc',
  'cá quả',
  'cá sặt',
  'cá tầm',
  'cá ông',
  'cá đối',
  'cán bộ',
  'câu cú',
  'câu đố',
  'cò con',
  'cò lửa',
  'có của',
  'có giá',
  'có khi',
  'có mặt',
  'có thể',
  'cô dâu',
  'cô hồn',
  'cô nhi',
  'cô đúc',
  'côn đồ',
  'chừ bự',
  'chữ số',
  'co dãn',
  'co kéo',
  'co rúm',
  'coi rẻ',
  'com lê',
  'con mẹ',
  'con số',
  'cu gáy',
  'cu sen',
  'cu đất',
  'cà bát',
  'cà dừa',
  'cà lăm',
  'cà ròn',
  'cà rỡn',
  'cà xóc',
  'cày mò',
  'cày úp',
  'cày ấp',
  'cá bơn',
  'cá dưa',
  'cá kim',
  'cá lóc',
  'cá lẹp',
  'cá mòi',
  'cá mập',
  'cá nục',
  'cá rựa',
  'cá sơn',
  'cá sộp',
  'cá tra',
  'cá voi',
  'cám ơn',
  'cát bá',
  'cát cứ',
  'câu kệ',
  'câu nệ',
  'cây cọ',
  'cây số',
  'cò cưa',
  'cò mồi',
  'có hậu',
  'có ích',
  'cô bác',
  'cô quả',
  'cô đơn',
  'chữ kí',
  'co bóp',
  'co vòi',
  'cocain',
  'com-pa',
  'con cò',
  'con cả',
  'con em',
  'con nợ',
  'con rạ',
  'con so',
  'con đẻ',
  'corpus',
  'cosine',
  'cotton',
  'cu gấm',
  'cua bể',
  'cua óp',
  'cuaroa',
  'cà gai',
  'cà mèn',
  'cà tím',
  'cà xốc',
  'càn rỡ',
  'cày vỡ',
  'cá bạc',
  'cá bột',
  'cá cơm',
  'cá heo',
  'cá hồi',
  'cá leo',
  'cá lúi',
  'cá lạc',
  'cá mối',
  'cá nhụ',
  'cá sấu',
  'cá thu',
  'cá thể',
  'cá trê',
  'cá vền',
  'cá đao',
  'cám dỗ',
  'cán sự',
  'cáo từ',
  'cát sê',
  'cân ta',
  'cân xô',
  'cây cỏ',
  'cây gỗ',
  'cãi cọ',
  'cãi vã',
  'có hạn',
  'có học',
  'có nhẽ',
  'cô hầu',
  'cô lập',
  'cô phụ',
  'cô đầu',
  'cô độc',
  'cù lao',
  'cù nèo',
  'căn hộ',
  'cơ bắp',
  'cơ chỉ',
  'cơ cấu',
  'cơ hữu',
  'cơ man',
  'cơ mưu',
  'cơ vân',
  'cơ địa',
  'cơm áo',
  'cơn cớ',
  'cư ngụ',
  'cư trú',
  'cưa xẻ',
  'cả tin',
  'cải bẹ',
  'cải tổ',
  'cảm tử',
  'cảm ơn',
  'cấm cố',
  'cấm kị',
  'cấn cá',
  'cất mộ',
  'cấu tứ',
  'cầm cố',
  'cần sa',
  'cầu an',
  'cầu tự',
  'cắc cớ',
  'cù mộc',
  'căn cơ',
  'căn cứ',
  'căn do',
  'căn tố',
  'cũ mèm',
  'cơ bản',
  'cơ chế',
  'cơ cầu',
  'cơ hàn',
  'cơ hội',
  'cơ khí',
  'cơ khổ',
  'cơ may',
  'cơ mầu',
  'cả cục',
  'cả gói',
  'cảm tạ',
  'cấp bộ',
  'cấp uỷ',
  'cấy mô',
  'cầm tù',
  'cần ta',
  'cần vụ',
  'cầu ao',
  'cầu kì',
  'cận kề',
  'cận vệ',
  'cậu ấm',
  'cắn xé',
  'cắt cổ',
  'cõi bờ',
  'cõi âm',
  'cù cưa',
  'cù lần',
  'cú mèo',
  'cúc cu',
  'cúm gà',
  'căm xe',
  'căn số',
  'cơ bẩm',
  'cơ cực',
  'cơ học',
  'cơ mật',
  'cơ nhỡ',
  'cơ thể',
  'cơ yếu',
  'cư dân',
  'cười ồ',
  'cả gan',
  'cả thể',
  'cải củ',
  'cải mả',
  'cảm từ',
  'cấm vệ',
  'cấp độ',
  'cất mả',
  'cất vó',
  'cấu xé',
  'cầm cự',
  'cầm đồ',
  'cần cù',
  'cần xé',
  'cầu là',
  'cẩm tú',
  'cập kê',
  'cắc kè',
  'cắm cổ',
  'cắn cỏ',
  'cắt cử',
  'cặp bồ',
  'cọ dầu',
  'cỏ cây',
  'cỏ gấu',
  'cỏ may',
  'cỏ năn',
  'cố kết',
  'cốc vũ',
  'cốt tử',
  'cổ giả',
  'cổ lai',
  'cổ lục',
  'cổ súy',
  'cổ tay',
  'cổ xưa',
  'cổ đại',
  'cỗ bàn',
  'cỗi rễ',
  'cột số',
  'cớ sao',
  'cờ vua',
  'cụ thể',
  'cục bộ',
  'củ mài',
  'củ não',
  'củ đậu',
  'cứt su',
  'cứu hộ',
  'cử tri',
  'cửa sổ',
  'cửa tử',
  'cực từ',
  'da bát',
  'da bốc',
  'da cóc',
  'da dầu',
  'da sần',
  'dao tu',
  'di bút',
  'di cảo',
  'di dân',
  'di hoạ',
  'domino',
  'du côn',
  'duy lí',
  'duy mỹ',
  'dàn bè',
  'dâm tà',
  'cặn bã',
  'cọ xát',
  'cỏ lác',
  'cỏ sữa',
  'cố chí',
  'cố sát',
  'cố thủ',
  'cố tật',
  'cổ cồn',
  'cổ kim',
  'cổ ngữ',
  'cổ thi',
  'cổ tức',
  'cổ vật',
  'cỗ ván',
  'cội rễ',
  'cờ bạc',
  'cờ chó',
  'cờ vây',
  'cởi mở',
  'củ cái',
  'củ cẩm',
  'củ năn',
  'của nợ',
  'cứa cổ',
  'cứu tế',
  'cử chỉ',
  'cửa bể',
  'cửa rả',
  'cửa ải',
  'cự phú',
  'cực kì',
  'cực độ',
  'da cam',
  'da màu',
  'da non',
  'danh y',
  'dao nề',
  'dao vọ',
  'di bản',
  'di căn',
  'di cốt',
  'di hại',
  'di sản',
  'di trú',
  'di tản',
  'di ảnh',
  'dioptr',
  'doping',
  'duy lý',
  'dân ca',
  'dân cư',
  'dân dã',
  'dân sự',
  'cặn kẽ',
  'cặp kè',
  'cỏ mật',
  'cố hữu',
  'cố lão',
  'cố tri',
  'cố vấn',
  'cố đạo',
  'cốc đế',
  'cổ suý',
  'cổ thụ',
  'cổ văn',
  'cổ xuý',
  'cờ bỏi',
  'cụ cựa',
  'cụ non',
  'cụm từ',
  'củ cải',
  'củ khỉ',
  'củ nâu',
  'củ đao',
  'của nả',
  'củi rả',
  'cức bì',
  'cứu độ',
  'cử toạ',
  'cửa mở',
  'cực kỳ',
  'cực tả',
  'da chì',
  'da dâu',
  'da gai',
  'da mồi',
  'da rạn',
  'dao mổ',
  'dao tể',
  'dao độ',
  'di chỉ',
  'di duệ',
  'di dời',
  'di hài',
  'di thể',
  'di vật',
  'diesel',
  'dioxin',
  'du học',
  'du mục',
  'duy mĩ',
  'duy tu',
  'dynamo',
  'dào ôi',
  'dân cử',
  'dân số',
  'dân vệ',
  'dâu da',
  'dã man',
  'dè dặt',
  'dép lê',
  'dì ghẻ',
  'dò dẫm',
  'dò tìm',
  'dơ bẩn',
  'dạ con',
  'dạ dày',
  'dạ yến',
  'dạy dỗ',
  'dấm dớ',
  'dần dà',
  'dầu mỡ',
  'dật sĩ',
  'dế mèn',
  'dễ dãi',
  'dễ thở',
  'dị hợm',
  'dị tật',
  'dớ dẩn',
  'dở bữa',
  'dụ khị',
  'dữ dằn',
  'dự thu',
  'dự trữ',
  'e-mail',
  'em gái',
  'eo xèo',
  'fe-rít',
  'formol',
  'ga xép',
  'galena',
  'gam-ma',
  'gan gà',
  'gay go',
  'ghi-ta',
  'ghi lò',
  'ghi âm',
  'dâu bể',
  'dây dợ',
  'dã thú',
  'dã tâm',
  'dãn nở',
  'dè bỉu',
  'dè sẻn',
  'dò hỏi',
  'dò xét',
  'dòm dỏ',
  'dơ dáy',
  'dưa bở',
  'dạ hội',
  'dạ đài',
  'dấm dứ',
  'dấu má',
  'dầu ta',
  'dật sử',
  'dễ coi',
  'dễ dầu',
  'dị vật',
  'dị ứng',
  'dối dá',
  'dồn tụ',
  'dở dói',
  'dở hơi',
  'dụng ý',
  'dữ dội',
  'dữ tợn',
  'dự báo',
  'dự chi',
  'e ngại',
  'e thẹn',
  'eo hẹp',
  'eo đất',
  'gai ốc',
  'gan lì',
  'ghê sợ',
  'dí dỏm',
  'dôi dư',
  'dù cho',
  'dù sao',
  'dúm dó',
  'dăm ba',
  'dư dật',
  'dưa lê',
  'dạ cửa',
  'dạ hợp',
  'dạ xoa',
  'dạn dĩ',
  'dấu mũ',
  'dấu ấn',
  'dầm dề',
  'dầu cá',
  'dầu mỏ',
  'dẫn độ',
  'dật dờ',
  'dặn dò',
  'dế dũi',
  'dị bản',
  'dị hoá',
  'dị hờm',
  'dồn ép',
  'dữ đòn',
  'dự cảm',
  'dự trù',
  'en-zim',
  'eng éc',
  'eo sèo',
  'eo ếch',
  'fo-mon',
  'ga-len',
  'ga men',
  'gan dạ',
  'ghe cộ',
  'ghẻ lở',
  'ghế bố',
  'gia cư',
  'gia sự',
  'giương',
  'giường',
  'giả bộ',
  'giả dụ',
  'giả lả',
  'giả vờ',
  'giỗ kỵ',
  'giở dạ',
  'glu-cô',
  'gà giò',
  'gia cố',
  'gia sư',
  'gia tư',
  'gia vị',
  'già cả',
  'giá mà',
  'giữ kẽ',
  'guitar',
  'gà gật',
  'gà lôi',
  'gà pha',
  'gà rốt',
  'gàn dở',
  'gày gò',
  'gây sự',
  'gia ân',
  'gia ơn',
  'giá cả',
  'giã từ',
  'giả da',
  'giả lơ',
  'giả sử',
  'giả tỉ',
  'giả đò',
  'giỗ kị',
  'guđron',
  'gà hoa',
  'gà nòi',
  'gà qué',
  'gà sao',
  'gà tây',
  'gác bỏ',
  'gân cổ',
  'gây gổ',
  'gây mê',
  'gây tê',
  'góc độ',
  'gầm rú',
  'gần xa',
  'gầy gò',
  'gật gù',
  'gắn bó',
  'gối vụ',
  'gồ ghề',
  'gỗ dác',
  'gỡ lỗi',
  'gợi mở',
  'hang ổ',
  'hay ho',
  'helium',
  'heroin',
  'hi-đrô',
  'hi hữu',
  'ho hen',
  'hoa lơ',
  'hoà âm',
  'hoá lí',
  'hoạ đồ',
  'hoả hổ',
  'góc tù',
  'gõ cửa',
  'gạ gẫm',
  'gầm gừ',
  'gặp gỡ',
  'gốc từ',
  'gỗ dán',
  'gỗ ván',
  'gộp đá',
  'gỡ rối',
  'hacker',
  'ham mê',
  'hoa lí',
  'hoa lệ',
  'hoá lý',
  'hoá ra',
  'hoạ mi',
  'hoả lò',
  'hoả mù',
  'hoả xa',
  'gạo tẻ',
  'gả bán',
  'gọi là',
  'gọn hơ',
  'gốc rễ',
  'gỗ tạp',
  'gỡ gạc',
  'gỡ tội',
  'gợi tả',
  'gửi rể',
  'ham hố',
  'han gỉ',
  'hay là',
  'hecto-',
  'hi hóp',
  'ho lao',
  'hoa lá',
  'hoa lý',
  'hoa mĩ',
  'hoa mỹ',
  'hoen ố',
  'hoạ sĩ',
  'hoạ âm',
  'hoả kế',
  'hà hơi',
  'hàm hồ',
  'hàn sĩ',
  'hàn vi',
  'hào lý',
  'hát ví',
  'hâm mộ',
  'hè hụi',
  'hèn hạ',
  'héc-ta',
  'hì hụp',
  'hí húi',
  'híp-pi',
  'hò reo',
  'hú hồn',
  'hú vía',
  'hăm he',
  'hơ hải',
  'hư hại',
  'hư đốn',
  'hạ bạc',
  'hạ cấp',
  'hạ sát',
  'hạ sơn',
  'hạ thế',
  'hạ thủ',
  'hạt dẻ',
  'hải hà',
  'hải ly',
  'hải vị',
  'hấm hứ',
  'hầm hố',
  'hầm mỏ',
  'hậu sự',
  'hậu tạ',
  'hắt xì',
  'hết dạ',
  'huý kị',
  'hàm số',
  'hàm ơn',
  'hàn lộ',
  'hàn xì',
  'há hốc',
  'hát bộ',
  'hát ru',
  'hì hục',
  'hí hởn',
  'hò hét',
  'hó háy',
  'hô hào',
  'hôn lễ',
  'hù doạ',
  'hú hoạ',
  'hư hao',
  'hạ bạn',
  'hạ chí',
  'hạ màn',
  'hạ thọ',
  'hải lí',
  'hải mã',
  'hải đồ',
  'hầm hừ',
  'hầu hạ',
  'hậu cứ',
  'hậu kì',
  'hậu vệ',
  'hắc ám',
  'hằm hừ',
  'huỷ bỏ',
  'hy hữu',
  'hà lạm',
  'hà rầm',
  'hà tất',
  'hàm ân',
  'hàm ẩn',
  'hàn ôn',
  'hào lí',
  'hát hò',
  'hèn gì',
  'hì hụi',
  'hí hoạ',
  'hít hà',
  'hò hẹn',
  'hòm xe',
  'hô hấp',
  'hôn mê',
  'hú tim',
  'hăm hở',
  'hư cấu',
  'hư hốt',
  'hư văn',
  'hạ bút',
  'hạ lưu',
  'hạ thổ',
  'hải li',
  'hải lý',
  'hải âu',
  'hầm hè',
  'hầm lò',
  'hậu bị',
  'hậu hĩ',
  'hậu tố',
  'hắc ín',
  'hằm hè',
  'hẹn hò',
  'hết lẽ',
  'hệ quả',
  'họ mạc',
  'học kỳ',
  'học vị',
  'hỏi dò',
  'hỏi vợ',
  'hồ cầm',
  'hồ hởi',
  'hồi cư',
  'hồi ký',
  'hồi ức',
  'hổ cốt',
  'hổ lốn',
  'hổ phù',
  'hỗn số',
  'hộ giá',
  'hội sở',
  'hội tụ',
  'hộp số',
  'hỡi ơi',
  'hợp lí',
  'hợp âm',
  'i-ô-ta',
  'im lìm',
  'in hệt',
  'inh ỏi',
  'khi dể',
  'khiêng',
  'khoảnh',
  'khu xử',
  'khuyết',
  'khuỷnh',
  'hề gậy',
  'hề mồi',
  'hệ tộc',
  'họ tộc',
  'học bạ',
  'học xá',
  'hồ thỉ',
  'hồi cố',
  'hồi tố',
  'hồi âm',
  'hổ lửa',
  'hỗ trợ',
  'hộ lại',
  'hớn hở',
  'hợp tử',
  'hủ bại',
  'hủ lậu',
  'hủ tục',
  'hữu cơ',
  'hữu tỉ',
  'in kim',
  'kem kí',
  'keo tơ',
  'kho tộ',
  'khoanh',
  'khuyên',
  'khuông',
  'hề hấn',
  'hệ luỵ',
  'hệ mét',
  'hệ đếm',
  'họ đạo',
  'học kì',
  'học sĩ',
  'hố đen',
  'hối hả',
  'hối lộ',
  'hồ hải',
  'hồi kí',
  'hội hè',
  'hội tề',
  'hởi dạ',
  'hỡi ôi',
  'hợp lý',
  'hợp lệ',
  'hợp số',
  'hợp đề',
  'hủ hoá',
  'hủ nho',
  'hữu tỷ',
  'im bặt',
  'im ắng',
  'in như',
  'karate',
  'kelvin',
  'kem ký',
  'khoang',
  'khoáng',
  'khoảng',
  'khoắng',
  'khuỳnh',
  'khí cụ',
  'khí áp',
  'khó dễ',
  'khả ái',
  'khổ sở',
  'kia mà',
  'kim cổ',
  'kè nhè',
  'kì cục',
  'kì hạn',
  'kì lân',
  'kì ngộ',
  'kì thị',
  'kì tài',
  'kì tập',
  'kí cóp',
  'kí giả',
  'kí quĩ',
  'kí tên',
  'kí tắt',
  'ký kết',
  'ký quỹ',
  'ký túc',
  'khí hư',
  'khối u',
  'kimono',
  'kéo bộ',
  'kéo gỗ',
  'kêu ca',
  'kì cựu',
  'kì thú',
  'kì thủ',
  'kì đài',
  'kí gửi',
  'kí hoạ',
  'kí lục',
  'kí quỹ',
  'kí túc',
  'ký chủ',
  'ký giả',
  'khí nổ',
  'khí số',
  'khí vị',
  'khả dĩ',
  'khệ nệ',
  'khố đỏ',
  'khổ ải',
  'ki cóp',
  'kèn co',
  'kéo co',
  'kêu la',
  'kì hào',
  'kì kèo',
  'kì mục',
  'kí chủ',
  'kí kết',
  'ký gửi',
  'ký hoạ',
  'ký lục',
  'ký tên',
  'ký tắt',
  'kết tụ',
  'kết án',
  'kề cận',
  'kỉ lục',
  'kỉ vật',
  'kị khí',
  'kỳ cục',
  'kỳ hạn',
  'kỳ lân',
  'kỳ ngộ',
  'kỳ thị',
  'kỳ tài',
  'kỳ tập',
  'kỷ lục',
  'kỷ vật',
  'kỹ xảo',
  'la bàn',
  'la lối',
  'lam lũ',
  'lambda',
  'lao lý',
  'lao tù',
  'lavabo',
  'lay ơn',
  'li-thi',
  'li tâm',
  'loã lồ',
  'ly hôn',
  'ly tâm',
  'làm gì',
  'làm ăn',
  'lá bắc',
  'lá cải',
  'lá kép',
  'lá lảu',
  'lá mía',
  'kẻ chợ',
  'kẻ cắp',
  'kẻo mà',
  'kế cận',
  'kết dư',
  'kỉ yếu',
  'kỳ cựu',
  'kỳ khu',
  'kỳ thú',
  'kỳ thủ',
  'kỳ đài',
  'kỵ khí',
  'kỷ yếu',
  'la rầy',
  'laptop',
  'latinh',
  'le lói',
  'len dạ',
  'lo lót',
  'làm bé',
  'làm cỏ',
  'làm lơ',
  'làm ma',
  'làm vì',
  'lá cẩm',
  'lá lẩu',
  'lá mầm',
  'lá sen',
  'lá toạ',
  'lái xe',
  'kĩ xảo',
  'kẻ thù',
  'kế tục',
  'kết từ',
  'kệ xác',
  'kỳ hào',
  'kỳ mục',
  'la hét',
  'lam-đa',
  'lao lí',
  'li-pít',
  'li hôn',
  'li tán',
  'lu loa',
  'ly tán',
  'là hơi',
  'làm bộ',
  'làm dữ',
  'làm lẽ',
  'làm ơn',
  'làm ải',
  'lá lốt',
  'lá mặt',
  'lái đò',
  'láu cá',
  'lâm ly',
  'lâm sự',
  'lè nhè',
  'lê thứ',
  'lì lợm',
  'lìa bỏ',
  'lí hào',
  'lí nhí',
  'lí thú',
  'líu lô',
  'lò chợ',
  'lò rèn',
  'lò đúc',
  'ló mặt',
  'lô lốc',
  'lú lẫn',
  'lúa má',
  'lý hào',
  'lý thú',
  'lý tài',
  'lũ lụt',
  'lơ thơ',
  'lạ lẫm',
  'lạ mặt',
  'lạ tai',
  'lạc đề',
  'lấn át',
  'lấy lệ',
  'lập lờ',
  'lật đổ',
  'lâm li',
  'lép vế',
  'lê dân',
  'lê lết',
  'lên án',
  'lí trí',
  'lò cao',
  'lót dạ',
  'lô nhô',
  'lùn tè',
  'lú nhú',
  'lúa mì',
  'lúa sạ',
  'lý trí',
  'lăn cù',
  'lơ ngơ',
  'lơi là',
  'lưu li',
  'lưu ly',
  'lạ nhà',
  'lạy tạ',
  'lấp ló',
  'lấy có',
  'lầm lỡ',
  'lần mò',
  'lập hạ',
  'lắc lư',
  'lân la',
  'lâu la',
  'lã chã',
  'lãi lờ',
  'lèo lá',
  'lê thê',
  'lí lắc',
  'líu lo',
  'lò chõ',
  'lòi xỉ',
  'lô cốt',
  'lù khù',
  'lú lấp',
  'lúa ma',
  'lăm le',
  'lăn xả',
  'lũ ống',
  'lơ láo',
  'lơ phơ',
  'lơi lả',
  'lạ mắt',
  'lạ đời',
  'lạc đà',
  'lả lơi',
  'lấp lú',
  'lấy nê',
  'lầm lì',
  'lập dị',
  'lập kế',
  'lập là',
  'lề lối',
  'lễ bái',
  'lễ hội',
  'lễ tân',
  'lệ phí',
  'lỗ chỗ',
  'lỗ lãi',
  'lỗ vốn',
  'lỗ đít',
  'lộ phí',
  'lộ tẩy',
  'lờ lãi',
  'lờ tịt',
  'lời lỗ',
  'lỡ lời',
  'lụa là',
  'lục sự',
  'lừ thừ',
  'ma men',
  'ma sát',
  'man di',
  'may vá',
  'mi-crô',
  'mo-rát',
  'mua độ',
  'màu mè',
  'mày mò',
  'lẻ loi',
  'lẽ mọn',
  'lễ lạt',
  'lễ vật',
  'lỗ đen',
  'lộ hầu',
  'lộn ẩu',
  'lột tả',
  'lớ ngớ',
  'lờ ngờ',
  'lở láy',
  'lở sơn',
  'lỡ tàu',
  'lợn cà',
  'lợn sề',
  'lụ khụ',
  'lủ khủ',
  'lừ khừ',
  'lừa mị',
  'lử thử',
  'lữ thứ',
  'ma lem',
  'ma mộc',
  'ma quỉ',
  'may mà',
  'may ra',
  'may so',
  'men sứ',
  'mo cau',
  'mua sỉ',
  'màu da',
  'màu mẽ',
  'mác-ma',
  'mát dạ',
  'máu dê',
  'lặc lè',
  'lẽ nào',
  'lễ đài',
  'lọ lem',
  'lọ nồi',
  'lố nhố',
  'lỗ đáo',
  'lội bộ',
  'lớ quớ',
  'lờ khờ',
  'lờ phờ',
  'lời lẽ',
  'lở lói',
  'lỡ lầm',
  'lỡ thì',
  'lử khử',
  'lực kế',
  'lực sĩ',
  'ma-giê',
  'ma dút',
  'ma két',
  'ma lực',
  'ma mút',
  'ma quỷ',
  'ma tuý',
  'man rợ',
  'mastic',
  'mau lẹ',
  'may đo',
  'mua lẻ',
  'mà lại',
  'mào gà',
  'màu mỡ',
  'má đào',
  'mát-xa',
  'mát mẻ',
  'máu me',
  'máy mó',
  'mây mù',
  'mã hoá',
  'mã tấu',
  'mê man',
  'mê mẩn',
  'mê tín',
  'mê đạo',
  'mò mẫm',
  'mó máy',
  'mô-đun',
  'mù mịt',
  'mù tăm',
  'mùa vụ',
  'mĩ học',
  'mũ cát',
  'mơ-nuy',
  'mơ ngủ',
  'mạo từ',
  'mạt kỳ',
  'mấp mé',
  'mấy nả',
  'mầu mè',
  'mầy mò',
  'mẫu số',
  'mập mờ',
  'mắc mỏ',
  'mắc áo',
  'mặc cả',
  'mặc kệ',
  'mặt số',
  'mệt lử',
  'mịt mù',
  'mỏ cặp',
  'mỏ neo',
  'mồ cha',
  'mộ chí',
  'mộ đạo',
  'máu mê',
  'máy in',
  'mân mê',
  'mã cân',
  'mã lực',
  'méo mó',
  'mê hồn',
  'mê mệt',
  'mê say',
  'mê tít',
  'mê đắm',
  'mía đỏ',
  'mó tay',
  'mô-đem',
  'mô-đéc',
  'môn đệ',
  'mù loà',
  'mù tạt',
  'mùi mẽ',
  'mùi vị',
  'mĩ cảm',
  'mĩ mãn',
  'mĩ tục',
  'mũ mão',
  'mưa lũ',
  'mưu cơ',
  'mưu kế',
  'mưu đồ',
  'mấp mô',
  'mấy ai',
  'mầu mẽ',
  'mẫu hệ',
  'mật mã',
  'mắc cỡ',
  'mắc mớ',
  'mắt cá',
  'mặn mà',
  'mẹ ghẻ',
  'mỏ hàn',
  'mồ côi',
  'mồ hôi',
  'mộ địa',
  'máu mủ',
  'máy nổ',
  'máy ủi',
  'mã não',
  'mãi lộ',
  'mê-tan',
  'mê mải',
  'mê ngủ',
  'mê tơi',
  'mía de',
  'mô-đen',
  'mô típ',
  'môn đồ',
  'mù chữ',
  'mù màu',
  'mù tịt',
  'mùi gì',
  'múa mỏ',
  'mĩ dục',
  'mũ mấn',
  'mũ nồi',
  'mũ trụ',
  'mơ ước',
  'mưa đá',
  'mưu mô',
  'mạt kì',
  'mải mê',
  'mầu mỡ',
  'mẫu mã',
  'mẫu ta',
  'mẫu tử',
  'mật vụ',
  'mật độ',
  'mặc dù',
  'mặt mo',
  'mặt nạ',
  'mẹ già',
  'mẹ mìn',
  'mến mộ',
  'mề đay',
  'mị dân',
  'mịt mờ',
  'mọi rợ',
  'mỏ lết',
  'mỏ vịt',
  'mốc xì',
  'một bề',
  'một tí',
  'mờ mịt',
  'mở cửa',
  'mở mắt',
  'mỡ khổ',
  'mỡ màu',
  'mỹ cảm',
  'mỹ mãn',
  'mỹ tục',
  'nam mô',
  'nam vô',
  'napalm',
  'newton',
  'nghiêm',
  'nghiến',
  'nghiện',
  'nghiệp',
  'ngon ơ',
  'ngu si',
  'nguyền',
  'nguyệt',
  'một số',
  'mới lạ',
  'mở màn',
  'mở mặt',
  'mở đầu',
  'mỡ máy',
  'mụ mẫm',
  'mỹ dục',
  'nam ai',
  'nem rế',
  'nghệch',
  'ngũ vị',
  'ngư hộ',
  'một ít',
  'mới mẻ',
  'mới đó',
  'mục sư',
  'mục từ',
  'mức độ',
  'mỹ học',
  'na-pan',
  'nam nữ',
  'nam tử',
  'nghiên',
  'nghiền',
  'nghiệm',
  'nghênh',
  'nghếch',
  'nghểnh',
  'nghịch',
  'ngoảnh',
  'nguyên',
  'nguyện',
  'ngũ âm',
  'ngư cụ',
  'nhi nữ',
  'nho sĩ',
  'nhoáng',
  'nhà bè',
  'nhà mồ',
  'nhà tu',
  'nhà xe',
  'nhà xí',
  'nhũ đá',
  'như ai',
  'nhượng',
  'ngưỡng',
  'ngụ cư',
  'ngủ mê',
  'nha sĩ',
  'nhuyễn',
  'nhà in',
  'nhà tù',
  'nhà đá',
  'nhướng',
  'ngượng',
  'ngả vạ',
  'ngủ gà',
  'ngữ hệ',
  'ngữ âm',
  'ngự sử',
  'ngựa ô',
  'nhoàng',
  'nhu mì',
  'nhà ga',
  'nhà sư',
  'nhà ăn',
  'nhường',
  'nhảy ổ',
  'nhị hỉ',
  'nhỏ lẻ',
  'nhờ vả',
  'nhừ tử',
  'nài ép',
  'nào là',
  'não nề',
  'ném tạ',
  'nê-ông',
  'nói gì',
  'năm ba',
  'nơ-ron',
  'nhẹ dạ',
  'nhẹ kí',
  'nhị hỷ',
  'nhỏ to',
  'nhỡ ra',
  'nickel',
  'nài nỉ',
  'này nọ',
  'nái sề',
  'nát-ri',
  'níu áo',
  'nói gở',
  'nói mê',
  'nói xỏ',
  'nô bộc',
  'năn nỉ',
  'nhẩy ổ',
  'nhẹ nợ',
  'nhỏ bé',
  'ni-ken',
  'non bộ',
  'nát óc',
  'nói mò',
  'nói vợ',
  'nón mê',
  'nô nức',
  'nô đùa',
  'nôm na',
  'nõn nà',
  'nằm mê',
  'nặc nô',
  'nặng è',
  'nếu mà',
  'nốc ao',
  'nổ mìn',
  'nộ khí',
  'nội đô',
  'nở hậu',
  'nợ nần',
  'nợ đời',
  'nữ nhi',
  'nữa là',
  'oa trữ',
  'oai vệ',
  'online',
  'oxygen',
  'oằn èo',
  'pa-nen',
  'pha lê',
  'phi cơ',
  'phi lý',
  'phu tử',
  'phá bỏ',
  'phá án',
  'nạt nộ',
  'nấm sò',
  'nấu ăn',
  'nẩy nở',
  'nắc nẻ',
  'nằm mơ',
  'nằm vạ',
  'nằn nì',
  'nết na',
  'nề nếp',
  'nền nã',
  'nỉ non',
  'nỏ mồm',
  'nội bộ',
  'nỡ nào',
  'nợ máu',
  'nợ đìa',
  'nứt nẻ',
  'nữ cao',
  'oi bức',
  'om sòm',
  'ong vẽ',
  'patanh',
  'phi dê',
  'phi lê',
  'phi mã',
  'phi vụ',
  'nảy nở',
  'nấm mỡ',
  'nấn ná',
  'nặn óc',
  'nếp tẻ',
  'nể mặt',
  'nịt vú',
  'nỗ lực',
  'nội tệ',
  'nội vụ',
  'nức nở',
  'oan ức',
  'ohm kế',
  'oặt ẹo',
  'oẻ hoẹ',
  'patinê',
  'phi lí',
  'photon',
  'phu la',
  'phá cỗ',
  'phá đề',
  'pháp y',
  'ô nhục',
  'ổ khóa',
  'ốc đảo',
  'ốc lồi',
  'ốc sên',
  'ốc vặn',
  'ôi chao',
  'ôi thôi',
  'ổi tàu',
  'ổi trâu',
  'ôm chân',
  'ôm đồm',
  'ốm đau',
  'ốm đòn',
  'ốm xác',
  'ốm yếu',
  'ốm nhom',
  'ôn con',
  'ôn dịch',
  'ôn đới',
  'ôn hòa',
  'ôn tập',
  'ôn tồn',
  'ôn vật',
  'ổn định',
  'ổn đáng',
  'ông bà',
  'ông cha',
  'ông địa',
  'ông gia',
  'ông già',
  'ông trẻ',
  'ông từ',
  'ông vải',
  'ông xã',
  'ồng ộc',
  'ốt dột',
  'ống nói',
  'ống thử',
  'ôtômat',
  'ôtôray',
  'ở không',
  'ở mướn',
  'ở riêng',
  'ở trần',
  'ơn huệ',
  'ơn nghĩa',
  'phò tá',
  'phó từ',
  'phù hộ',
  'phù nề',
  'phù rể',
  'phượng',
  'phế đế',
  'phổ độ',
  'phụ nữ',
  'phụ từ',
  'phụ đề',
  'picnic',
  'proton',
  'qui củ',
  'quy củ',
  'quá đà',
  'quá độ',
  'phó sứ',
  'phù du',
  'phù sa',
  'phú hộ',
  'phương',
  'phường',
  'phả hệ',
  'phật ý',
  'phố xá',
  'phổ hệ',
  'phụ tá',
  'phụ tử',
  'phụ âm',
  'pi-rít',
  'qui tụ',
  'quy tụ',
  'quá cố',
  'quá xá',
  'phò mã',
  'phô-tô',
  'phù kế',
  'phế bỏ',
  'phổ kế',
  'phụ hệ',
  'phụ tố',
  'pi-gia',
  'plasma',
  'pơluya',
  'qui mô',
  'quy mô',
  'quá bộ',
  'quá cỡ',
  'quỉ kế',
  'quỉ sứ',
  'ra mặt',
  'ra oai',
  'ra sức',
  'rau cỏ',
  'rau mơ',
  'ru ngủ',
  'rum-ba',
  'run sợ',
  'rái cá',
  'rô-bốt',
  'rúm ró',
  'rơm rạ',
  'rầm rì',
  'rầu rĩ',
  'rầy la',
  'quân y',
  'quí hồ',
  'quí tử',
  'quý hồ',
  'quý tử',
  'ra hồn',
  'ra rìa',
  'ra tay',
  'radian',
  'radium',
  'reo hò',
  'ru hời',
  'rà rẫm',
  'rã rời',
  'rên rỉ',
  'rì rầm',
  'răn đe',
  'rũ rợi',
  'rạn vỡ',
  'rầm rĩ',
  'rậm rì',
  'rằn ri',
  'rẽ ròi',
  'quí vị',
  'quý vị',
  'quỷ kế',
  'quỷ sứ',
  'ra mắt',
  'ra trò',
  'ra đời',
  'rau má',
  'rocket',
  'rã đám',
  'rên la',
  'rì rào',
  'rôm rả',
  'rõ rệt',
  'rầm rộ',
  'rầy rà',
  'rẻ mạt',
  'rẽ rọt',
  'rễ cọc',
  'rọ mõm',
  'rối bù',
  'rối mù',
  'rỗ hoa',
  'rờ rẫm',
  'rủi ro',
  'sa lầy',
  'sa mạc',
  'sa sâm',
  'sa sầm',
  'sai số',
  'se sua',
  'stator',
  'sulfur',
  'sum sê',
  'suy tỵ',
  'sà lan',
  'sán lá',
  'sáng ý',
  'sâu đo',
  'sì sụp',
  'súp lơ',
  'săm se',
  'sơ chế',
  'sơ sót',
  'sơn nữ',
  'rền rĩ',
  'rỉ tai',
  'rọ rạy',
  'rồi ra',
  'rộn rã',
  'rụt rè',
  'rủa sả',
  'sa bàn',
  'sa ngã',
  'sa sút',
  'sa sẩy',
  'sao la',
  'se sắt',
  'silica',
  'siphon',
  'so đũa',
  'stereo',
  'studio',
  'suy lí',
  'suy lý',
  'suy tị',
  'suy vi',
  'sài hồ',
  'sàm sỡ',
  'sáo cũ',
  'sâu bọ',
  'sâu xa',
  'sĩ khí',
  'sơ cấp',
  'sơ học',
  'sơ kết',
  'sơ tán',
  'sơn dã',
  'sơn hà',
  'rệu rã',
  'rồ dại',
  'rời rã',
  'rực rỡ',
  'sa bồi',
  'sa lát',
  'sa đoạ',
  'san hô',
  'san sẻ',
  'san ủi',
  'sao sa',
  'say mê',
  'sonata',
  'stress',
  'su hào',
  'suy bì',
  'suy tư',
  'sân cỏ',
  'sĩ phu',
  'sơ cứu',
  'sơ sài',
  'sơ sẩy',
  'sơ yếu',
  'sơn ca',
  'sơn hệ',
  'sư sãi',
  'sư ông',
  'sạt lở',
  'sấm ký',
  'sấn sổ',
  'sầm sì',
  'sắc tố',
  'sắc độ',
  'sọ dừa',
  'số cào',
  'số hoá',
  'số trừ',
  'sổ mũi',
  'sổ đen',
  'sởn sơ',
  'sợ sệt',
  'sứ giả',
  'sứt mẻ',
  'sử thi',
  'sự thể',
  'ta luy',
  'tai vạ',
  'tan rã',
  'tannin',
  'tatăng',
  'tay áo',
  'te tái',
  'tha hồ',
  'thi ca',
  'thi lễ',
  'sư mẫu',
  'sầu bi',
  'sẻn so',
  'số gia',
  'số một',
  'sờ sẫm',
  'sờm sỡ',
  'sở cầu',
  'sở hữu',
  'sở tại',
  'sức ép',
  'sử gia',
  'tai ác',
  'tay ba',
  'te tét',
  'tha ma',
  'thi sĩ',
  'thi ân',
  'sơn xì',
  'sư bác',
  'sư phụ',
  'sấm kí',
  'sầu tư',
  'sắt đá',
  'sặc sỡ',
  'số học',
  'số đối',
  'sốt vó',
  'sổ tay',
  'sợ hãi',
  'sụp đổ',
  'sử học',
  'sự thế',
  'sự vật',
  'sự đời',
  'ta đây',
  'tai-ga',
  'tan vỡ',
  'tay bo',
  'tay ấn',
  'te tua',
  'tham ô',
  'thi bá',
  'thi cử',
  'thi tứ',
  'thi vị',
  'thiêng',
  'thuổng',
  'thà là',
  'thái y',
  'thì là',
  'thí bỏ',
  'thò lò',
  'thô lỗ',
  'thô sơ',
  'thôn ổ',
  'thư kí',
  'thư ký',
  'thoáng',
  'thu lu',
  'thuyết',
  'thê tử',
  'thì có',
  'thù lù',
  'thú dữ',
  'thú vị',
  'thơ ca',
  'thơ ấu',
  'thoảng',
  'thu ba',
  'thuyền',
  'thâm u',
  'thâm ý',
  'thè lè',
  'thì ra',
  'thí dụ',
  'thô bỉ',
  'thô lố',
  'thơ từ',
  'thư từ',
  'thế hệ',
  'thế là',
  'thế ra',
  'thể lệ',
  'thị nữ',
  'thị tứ',
  'thị uỷ',
  'thổ mộ',
  'thờ tự',
  'thợ hồ',
  'thợ nề',
  'thụ lí',
  'thủ bạ',
  'thủ tự',
  'thứ tự',
  'ti toe',
  'thương',
  'thượng',
  'thả bộ',
  'thế kỉ',
  'thế sự',
  'thế tử',
  'thị tì',
  'thị tỳ',
  'thị vệ',
  'thỏ đế',
  'thổ cư',
  'thổ tả',
  'thụ lý',
  'thủ đô',
  'ti thể',
  'thường',
  'thưởng',
  'thẻ đỏ',
  'thế kỷ',
  'thế mà',
  'thị uy',
  'thị xã',
  'thổ lộ',
  'thổ âm',
  'thớ lợ',
  'thợ cả',
  'thụ án',
  'thủ từ',
  'thứ ba',
  'thứ nữ',
  'thứ sử',
  'thứ tư',
  'ti-tan',
  'to con',
  'to mồm',
  'ton tả',
  'tri-ốt',
  'tri hô',
  'tru di',
  'truyền',
  'truyện',
  'trà mi',
  'trù ẻo',
  'trú ẩn',
  'trơ lì',
  'trẻ mỏ',
  'trị an',
  'trợ từ',
  'trừ bị',
  'tuabin',
  'to gan',
  'to nhỏ',
  'to đầu',
  'toa xe',
  'toilet',
  'toà án',
  'toạ độ',
  'tri kỉ',
  'tri âm',
  'triêng',
  'triềng',
  'truồng',
  'trây ì',
  'trò hề',
  'trò vè',
  'trù bị',
  'trương',
  'trướng',
  'trường',
  'trượng',
  'trị số',
  'trở dạ',
  'trợ lí',
  'trụ sở',
  'trừ bỏ',
  'tu chí',
  'tu kín',
  'tu thư',
  'tim la',
  'tinh ý',
  'to lớn',
  'to tát',
  'tri kỷ',
  'tri ân',
  'truông',
  'trà lá',
  'trí sĩ',
  'trí óc',
  'trò ma',
  'trù úm',
  'trưởng',
  'trẻ em',
  'trị sự',
  'trị vì',
  'trợ lý',
  'trợ tá',
  'trừ bì',
  'trừ tà',
  'tu sửa',
  'tu tạo',
  'tuynen',
  'tài ba',
  'tài xế',
  'tàn tạ',
  'tàn ác',
  'tàu bè',
  'tán xạ',
  'tâm tư',
  'tân kỳ',
  'tên tự',
  'tình ý',
  'tín đồ',
  'tóm cổ',
  'tô mộc',
  'tôi tớ',
  'tôm he',
  'tù tội',
  'tù đầy',
  'tú tài',
  'tơ hào',
  'tư bản',
  'tư gia',
  'tạ thế',
  'tạm bợ',
  'tạp âm',
  'tả hữu',
  'tản cư',
  'tầm cỡ',
  'tẩy uế',
  'tập sự',
  'tập ấm',
  'tắc-te',
  'tắc kè',
  'tắp lự',
  'tế bào',
  'tế nhị',
  'tết ta',
  'tề tựu',
  'tệ hại',
  'tỉ đối',
  'tố khổ',
  'tốc ký',
  'tối kị',
  'tối om',
  'tối đa',
  'tối ưu',
  'tốt mã',
  'tội đồ',
  'tới số',
  'tờ gấp',
  'tờ rời',
  'tụ hội',
  'tụ tập',
  'tục lệ',
  'tủ chè',
  'tứ chi',
  'tứ quý',
  'tứ thư',
  'tứ tán',
  'tứ đức',
  'tức là',
  'từ hôn',
  'từ láy',
  'từ nan',
  'từ ngữ',
  'tử ngữ',
  'tử thi',
  'tử địa',
  'tự cao',
  'tự cấp',
  'tự lập',
  'tự mãn',
  'tự sát',
  'tự thú',
  'tự tin',
  'tự tín',
  'tự tận',
  'tự vẫn',
  'tựa hồ',
  'tuỳ cơ',
  'tà dâm',
  'tà tâm',
  'tà đạo',
  'tài tử',
  'tàn dư',
  'tái tê',
  'táo ta',
  'tâm lí',
  'tâm lý',
  'tây vị',
  'té tát',
  'tê tái',
  'tí tởn',
  'tía tô',
  'tô-tem',
  'tôm sú',
  'tôn ti',
  'tù hãm',
  'tơ lụa',
  'tơ tằm',
  'tơi tả',
  'tư hữu',
  'tư thù',
  'tư thế',
  'tư văn',
  'tạp kĩ',
  'tạp ăn',
  'tấm bé',
  'tất cả',
  'tẩm bổ',
  'tẩu mã',
  'tận số',
  'tập vở',
  'tắc-xi',
  'tẽn tò',
  'tế bần',
  'tế tửu',
  'tề gia',
  'tệ nạn',
  'tỉ giá',
  'tỉ như',
  'tịt mù',
  'tỏi gà',
  'tố nga',
  'tối kỵ',
  'tối mò',
  'tốp ca',
  'tốt số',
  'tồn dư',
  'tổ cha',
  'tổ tôm',
  'tổ đỉa',
  'tội nợ',
  'tội vạ',
  'tột độ',
  'tờ hoa',
  'tụ hợp',
  'tủ sắt',
  'tứ lục',
  'tứ sắc',
  'tức vị',
  'từ giã',
  'từ tâm',
  'tử nạn',
  'tử thù',
  'tử thủ',
  'tử tội',
  'tự lực',
  'tự phụ',
  'tự thị',
  'tự tôn',
  'tự tại',
  'tà khí',
  'tà vẹt',
  'tài vụ',
  'tàn tệ',
  'tàu hũ',
  'tá hoả',
  'tá túc',
  'tái cử',
  'tâm sự',
  'tân kì',
  'tã lót',
  'tê dại',
  'tì vết',
  'tí hon',
  'tí teo',
  'tí tẹo',
  'tí xíu',
  'tín nữ',
  'tít mù',
  'tóc tơ',
  'tóp mỡ',
  'tù đày',
  'túc hạ',
  'tơ tóc',
  'tư duy',
  'tư lợi',
  'tư sản',
  'tư túi',
  'tư vấn',
  'tạm cư',
  'tạp dề',
  'tạp kỹ',
  'tạp vụ',
  'tả tơi',
  'tả đạo',
  'tản bộ',
  'tảo mộ',
  'tấn sĩ',
  'tất tả',
  'tầm tã',
  'tần số',
  'tắc tị',
  'tệ bạc',
  'tệ tục',
  'tỉ mẩn',
  'tỉ phú',
  'tỉ thí',
  'tị nạn',
  'tỏ bày',
  'tố cáo',
  'tốc kí',
  'tốc độ',
  'tối dạ',
  'tối hù',
  'tối mù',
  'tồi tệ',
  'tổ hợp',
  'tổ phụ',
  'tội gì',
  'tội ác',
  'tờ-rớt',
  'tờ mây',
  'tờ rơi',
  'tụ họp',
  'tục tử',
  'tủi hổ',
  'tứ kết',
  'tứ quí',
  'tứ trụ',
  'từ hoá',
  'từ học',
  'từ mẫu',
  'từ tốn',
  'tử quy',
  'tử vận',
  'tự chủ',
  'tự cảm',
  'tự hào',
  'tự nhủ',
  'tự trị',
  'tự túc',
  'tự tạo',
  'tự vấn',
  'tự đắc',
  'tỷ như',
  'tỷ đối',
  'u hoài',
  'u nang',
  'u trầm',
  'uy thế',
  'uế tạp',
  'uốn éo',
  'uỷ trị',
  'va đập',
  'vai vế',
  'van vỉ',
  've vẩy',
  'vi-xcô',
  'violon',
  'vu hồi',
  'vá víu',
  'váy áo',
  'vân vi',
  'vân vũ',
  'vây ép',
  'véc-ni',
  'vì cầu',
  'vì sao',
  'ví dầu',
  'ví như',
  'ví von',
  'vó câu',
  'vô bào',
  'vô can',
  'vô cảm',
  'vô hại',
  'vô học',
  'vô hồn',
  'vô lại',
  'vô tri',
  'vô tận',
  'vô tội',
  'vô vàn',
  'vô ích',
  'võ lâm',
  'võ phu',
  'võ đài',
  'vú sữa',
  'văn võ',
  'vũ bão',
  'vũ khí',
  'vũ phu',
  'vũ đạo',
  'vơ vất',
  'vạ lây',
  'vạ vật',
  'vải bò',
  'vất vả',
  'vần vò',
  'vần vụ',
  'vận số',
  'vật lí',
  'vật tư',
  'vật vờ',
  'vậy mà',
  'vắt sổ',
  'vắt óc',
  'vẽ vời',
  'vỉa hè',
  'vị ngữ',
  'vị trí',
  'vỏ bào',
  'vỏ lụa',
  'vốn dĩ',
  'vồ vập',
  'vờ vịt',
  'vợ nhỏ',
  'webcam',
  'xa gần',
  'xa lắc',
  'xa tít',
  'xa vời',
  'xa xót',
  'xa xưa',
  'xe con',
  'xe gíp',
  'xe hoả',
  'xe lam',
  'xe lăn',
  'xe lửa',
  'xe nôi',
  'xe thồ',
  'xo-nat',
  'xu phụ',
  'xu xoa',
  'xà cột',
  'xà kép',
  'xà mâu',
  'xà ích',
  'xã hội',
  'xã tắc',
  'xét xử',
  'xì xầm',
  'tỷ giá',
  'tỷ phú',
  'tỷ thí',
  'u buồn',
  'um sùm',
  'un đúc',
  'uy lực',
  'uy tín',
  'uý lạo',
  'uể oải',
  'vắcxin',
  'vi-rút',
  'vi nấm',
  'vi vút',
  'vu qui',
  'vào sổ',
  'véc-tơ',
  'vét xi',
  'vì kèo',
  'vì thế',
  'ví dặm',
  'vô hạn',
  'vô sản',
  'vô tài',
  'võ lực',
  'văn tế',
  'văn vũ',
  'văn vẻ',
  'vũ lực',
  'vũ trụ',
  'vơ vẩn',
  'vạ vịt',
  'vạm vỡ',
  'vả lại',
  'vấn đề',
  'vất vơ',
  'vần vũ',
  'vật lý',
  'vị lai',
  'vị thế',
  'vị tất',
  'vọp bẻ',
  'vỏ não',
  'vồ ếch',
  'vỗ tay',
  'vớ bẫm',
  'vớ vẩn',
  'vỡ chợ',
  'vợ con',
  'vụ lợi',
  'xa hoa',
  'xa lìa',
  'xa tắp',
  'xa xôi',
  'xamôva',
  'xe-non',
  'xe bãi',
  'xe bồn',
  'xe máy',
  'xe tải',
  'xen kẽ',
  'xin xỏ',
  'xiêm y',
  'xoá bỏ',
  'xoá sổ',
  'xu-páp',
  'xu thế',
  'xà bần',
  'xà lan',
  'xà đơn',
  'xàm xỡ',
  'xá xíu',
  'xác vờ',
  'xé rào',
  'xì dầu',
  'xì xào',
  'xì xục',
  'xí bệt',
  'xí xoá',
  'um tùm',
  'uất ức',
  'uế khí',
  'uỷ ban',
  'uỷ lạo',
  'va vấp',
  've sầu',
  've vãn',
  'vector',
  'ven đô',
  'vernis',
  'vi thể',
  'violet',
  'vu cáo',
  'vu oan',
  'vu quy',
  'vui vẻ',
  'vài ba',
  'vào đề',
  'vày vò',
  'vân vê',
  'vì vậy',
  'ví thử',
  'vô chủ',
  'vô cực',
  'vô giá',
  'vô hậu',
  'vô lối',
  'vô tâm',
  'vô đạo',
  'võ khí',
  'vú già',
  'văn sĩ',
  'văn tự',
  'vĩ cầm',
  'vĩ đại',
  'vũ hội',
  'vũ đài',
  'vơ vét',
  'vạn đò',
  'vấn an',
  'vần vè',
  'vầy vò',
  'vẩn vơ',
  'vật vã',
  'vẹo vọ',
  'vẽ trò',
  'vị chi',
  'vị ngã',
  'vị tha',
  'vịt cỏ',
  'vỏ lải',
  'vồn vã',
  'vỗ béo',
  'vội vã',
  'vờ vẫn',
  'vởn vơ',
  'vỡ vạc',
  'vợ lớn',
  'ứ đọng',
  'ưa nhìn',
  'ưa thích',
  'ức chế',
  'ưng ức',
  'ừng ực',
  'ứng cử',
  'ứng cứu',
  'ứng đối',
  'ứng đáp',
  'ứng lực',
  'ứng mộ',
  'ứng phó',
  'ứng tác',
  'ứng thí',
  'ứng xử',
  'ước ao',
  'ước lệ',
  'ước mơ',
  'ước số',
  'ưỡn ẹo',
  'ướt át',
  'ưu đãi',
  'ưu sầu',
  'ưu thế',
  'x-quang',
  'xa cách',
  'xa cảng',
  'xa gần',
  'xa giá',
  'xa hoa',
  'xa khơi',
  'xa lánh',
  'xa lắc',
  'xa lìa',
  'xa lông',
  'xa ngái',
  'xa phí',
  'xa rời',
  'xa tanh',
  'xa tắp',
  'xa thẳm',
  'xa tít',
  'xa vắng',
  'xa vời',
  'xa xăm',
  'xa xẩn',
  'xa xôi',
  'xa xưa',
  'xà beng',
  'xà bông',
  'xà cạp',
  'xà cột',
  'xà đơn',
  'xà ích',
  'xà kép',
  'xà lách',
  'xà lan',
  'xà lệch',
  'xà lim',
  'xà lỏn',
  'xà mâu',
  'xà ngang',
  'xà phòng',
  'xà rông',
  'xà tích',
  'xà xẻo',
  'xả hơi',
  'xả láng',
  'xả thân',
  'xã giao',
  'xã hội',
  'xã tắc',
  'xá xíu',
  'xạ giới',
  'xạ kích',
  'xạ thủ',
  'xác vờ',
  'xác xơ',
  'xài phí',
  'xàm xỡ',
  'xàng xê',
  'xanh cỏ',
  'xanh lơ',
  'xanh lè',
  'xanh rì',
  'xanh um',
  'xảo trá',
  'xấu hổ',
  'xấu số',
  'xấu xa',
  'xấu xí',
  'xe con',
  'xe đạp',
  'xe gíp',
  'xe hỏa',
  'xe hòm',
  'xe hơi',
  'xe kéo',
  'xe khách',
  'xe lam',
  'xe lửa',
  'xe máy',
  'xe ngựa',
  'xe nôi',
  'xe pháo',
  'xe quệt',
  'xe tải',
  'xe tay',
  'xe tăng',
  'xe thồ',
  'xé phay',
  'xé rào',
  'xé xác',
  'xelulo',
  'xem ra',
  'xen kẽ',
  'xẹo xọ',
  'xét xử',
  'xí gạt',
  'xích đu',
  'xích lô',
  'xiêm y',
  'xiên xỏ',
  'xifông',
  'xilanh',
  'xi măng',
  'ximăng',
  'xin quẻ',
  'xin xỏ',
  'xinhan',
  'xi nhan',
  'xiphông',
  'xỏ mũi',
  'xỏ ngọt',
  'xó xỉnh',
  'xói lở',
  'xót xa',
  'xô đẩy',
  'xôviêt',
  'xô xát',
  'xối xả',
  'xống áo',
  'xơ cua',
  'xơ gan',
  'xơ hóa',
  'xơ múi',
  'xơ xác',
  'xờ xạc',
  'xu nịnh',
  'xu phụ',
  'xu thế',
  'xu thời',
  'xu xoa',
  'xú khí',
  'xúc tu',
  'xụi lơ',
  'xúp lê',
  'xí xóa',
  'xử thế',
  'xử thử',
  'xử trảm',
  'xử trí',
  'xứ đạo',
  'xưng hô',
  'xửng cồ',
  'y khoa',
  'y lệnh',
  'y phục',
  'y viện',
  'ý chừng',
  'ý định',
  'ý kiến',
  'ý muốn',
  'ý nghĩ',
  'ý nghĩa',
  'ý niệm',
  'ý thức',
  'ý tình',
  'ý tưởng',
  'yểm hộ',
  'yểm trợ',
  'yểm trừ',
  'yếm khí',
  'yếm thế',
  'yên ắng',
  'yên hà',
  'yên ổn',
  'yên trí',
  'yên ủi',
  'yên vị',
  'yến anh',
  'yến ẩm',
  'yết giá',
  'yết thị',
  'yêu ma',
  'yêu quí',
  'yêu vì',
  'yểu tử',
  'yếu ớt',
  'yếu thế',
  'yếu tố',
  'ziczac',
  'bóng gió',
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
